const GpsManager = {};

var device = '';
var latitude = '';
var longitude = '';

GpsManager.init = (pDevice) => {
    device = pDevice;
}

GpsManager.setLatitudeAndLongitude = (pLatitude, pLongitude) => {
    latitude = pLatitude;
    longitude = pLongitude;
};

//ios만
GpsManager.getLocation = async() => {
    // var device = this.$cookies.get("device");
    let locationStr = "";

    if(device === 'android'){
        locationStr = window.Android.getLastLocation();
        const locationArr = locationStr.split(',');
        latitude = locationArr[0];
        longitude = locationArr[1];
    }else if(device === 'ios') {
        /*eslint-disable no-undef */
        webkit.messageHandlers.ios.postMessage({cmd: 'setLatitudeAndLongitude'});
        await waitMiliSeconds(100);
    }else if(device === 'pc') {

        navigator.geolocation.getCurrentPosition((res) => {
            console.log("browser location success : ",res);
            latitude = res.coords.latitude;
            longitude = res.coords.longitude;
        },(err)=>{
            console.log("browser location error : ",err);
        });
        await waitMiliSeconds(100);

    }else {
        latitude = process.env.VUE_APP_LATITUDE;
        longitude = process.env.VUE_APP_LONGTITUDE;
    }

    return {latitude : latitude, longitude : longitude};
};

function waitMiliSeconds(time) {
    return new Promise(resolve => {
        setTimeout(() => {
            resolve();
        }, time);
    });
}

// const GpsManager = (function(){

// })();

window.GpsManager = GpsManager;

export default GpsManager;
